import React, { useReducer, useEffect, useContext, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import axios from "../../../config/axios";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import { ContainerLoading } from "../../UI/loading/ContainerLoading";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import moduleConfig from "./moduleConfig";
import {
  detailsReducer,
  memberDetailsInitialState,
} from "./reducers/detailsReducer";
import Details from "./partials/details/Details";
import MemberRecentRegistrations from "./partials/details/MemberRecentRegistrations";
import MemberRecentPayments from "./partials/details/MemberRecentPayments";
import MemberCircles from "./partials/details/MemberCircles";
import useConfirm from "../../../HOC/custom/useConfirm";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../config/toastNotification";
import { Button, Dropdown } from "react-bootstrap";
import SignupRequestRejectModal from "./partials/details/SignupRequestRejectModal";
import MemberBlockModal from "./partials/details/MemberBlockModal";
import { AuthContext } from "../../../contexts/AuthContext";
import AddMembershipIdModal from "./partials/details/AddMembershipIdModal";
import ChangeMemberRoleModal from "./partials/details/ChangeMemberRoleModal";
import DetailsSignup from "./partials/details/DetailsSignup";
import MemberArchiveModal from "./partials/details/MemberArchiveModal";
import MemberReactivateModal from "./partials/details/MemberReactivateModal";
import ChangeMemberEmailModal from "./partials/details/ChangeMemberEmailModal";
import ChangeMembershipIdModal from "./partials/details/ChangeMembershipIdModal";
let breadcrumbs = {
  listing: {
    label: moduleConfig.title,
    url: `/${moduleConfig.url}`,
  },
  details: {
    label: "Details",
  },
};

const MemberView = () => {
  const { userAuthState } = useContext(AuthContext);
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  const [detailsState, detailsDispatch] = useReducer(
    detailsReducer,
    memberDetailsInitialState,
  );
  const [showRejectionModal, setShowRejectionModal] = useState(false);
  const [showAddMembershipIdModal, setShowAddMembershipIdModal] =
    useState(false);
  const [showChangeMemberRoleModal, setShowChangeMemberRoleModal] =
    useState(false);
      const [showChangeMembershipIdModal, setShowChangeMembershipIdModal] =
    useState(false);
  const [showChangeEmailModal, setShowChangeEmailModal] = useState(false);
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [showReactivateModal, setShowReactivateModal] = useState(false);
  let { id } = useParams();
  const { confirm } = useConfirm();

  // { console.log("userAuthState user ==>", userAuthState.user) }
  const loadItem = async () => {
    if (id) {
      detailsDispatch({
        type: "FETCH_REQUEST",
      });

      try {
        const res = await axios.get(`${moduleConfig.url}/details/${id}`); //
        detailsDispatch({
          type: "FETCH_SUCCESS",
          payload: res.data,
        });
      } catch (error) {
        detailsDispatch({
          type: "FETCH_FAILURE",
          payload: error,
        });
      }
    }
  };
  useEffect(() => {
    loadItem();
    setBreadcrumb([breadcrumbs.listing, breadcrumbs.details]);
  }, [id]);

  const confirmAndRespondToSignupRequest = async (id, accept) => {
    const isConfirmed = await confirm(
      `Do you really want to ${
        accept ? "accept" : "reject"
      } the signup request?`,
    );

    if (isConfirmed) {
      if (accept) {
        console.log("accepted");

        setShowAddMembershipIdModal(true);

        //await respondToSignupRequest(id, accept);
      } else {
        console.log("reject");
        setShowRejectionModal(true);
      }
    }
  };

  // const respondToSignupRequest = async (id, accept = false, comments = "") => {
  //   detailsDispatch({
  //     type: "FETCH_REQUEST",
  //   });

  //   try {
  //     const res = await axios.post(
  //       `${moduleConfig.url}/respond-to-signup-request`,
  //       {
  //         id,
  //         accept,
  //         comments,
  //       }
  //     );
  //     loadItem();

  //     toast.addNotification({
  //       ...toastNotification,
  //       title: "Success!",
  //       message: `Signup request is ${accept ? "accepted" : "rejected"}.`,
  //       type: "success",
  //     });
  //   } catch (error) {
  //     detailsDispatch({
  //       type: "FETCH_FAILURE",
  //       payload: error,
  //     });
  //     toast.addNotification({
  //       ...toastNotification,
  //       title: "Error!",
  //       message: `Action failed.`,
  //       type: "danger",
  //     });
  //     setTimeout(() => {
  //       detailsDispatch({
  //         type: "REMOVE_ERROR",
  //       });
  //     }, 5000);
  //   }
  // };

  const confirmAndEmailPassword = async (id, block) => {
    const isConfirmed = await confirm(
      `Do you really want to email the new password?`,
    );

    if (isConfirmed) {
      await sendPasswordEmail(id);
    }
  };

  const sendPasswordEmail = async (id) => {
    detailsDispatch({
      type: "FETCH_REQUEST",
    });

    try {
      const res = await axios.post(`${moduleConfig.url}/send-password-email`, {
        id,
      });

      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `New password sent successfully.`,
        type: "success",
      });
      detailsDispatch({
        type: "REMOVE_LOADING",
      });
    } catch (error) {
      toast.addNotification({
        ...toastNotification,
        title: "Alert!",
        message: `Action failed, try again later.`,
        type: "danger",
      });

      detailsDispatch({
        type: "REMOVE_LOADING",
      });
    }
  };

  const confirmAndChangeBlockStatus = async (id, block) => {
    const isConfirmed = await confirm(
      `Do you really want to ${block ? "block" : "unblock"} this ${
        moduleConfig.singleItemTitle
      }?`,
    );

    if (isConfirmed) {
      await blockItem(id, block);
    }
  };

  const blockItem = async (id, block = false) => {
    detailsDispatch({
      type: "FETCH_REQUEST",
    });

    try {
      const res = await axios.post(`${moduleConfig.url}/block-item`, {
        id,
        block,
      });
      loadItem();
      // detailsDispatch({
      //     type: "DELETE_SUCCESS"
      // });
      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `${moduleConfig.singleItemTitle} ${
          block ? "blocked" : "unblocked"
        } successfully.`,
        type: "success",
      });
    } catch (error) {
      detailsDispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });

      setTimeout(() => {
        detailsDispatch({
          type: "REMOVE_ERROR",
        });
      }, 5000);
    }
  };

  const confirmAndReactivate = async (id) => {
    const isConfirmed = await confirm(
      `Do you really want to reactivate this member?`,
    );

    if (isConfirmed) {
      setShowReactivateModal(true);
    }
  };

  const confirmAndChangeArchiveStatus = async (id, archive) => {
    const isConfirmed = await confirm(
      `Do you really want to ${archive ? "archive" : "undo archive"} this ${
        moduleConfig.singleItemTitle
      }?`,
    );

    if (isConfirmed) {
      if (archive) {
        setShowArchiveModal(true);
      } else {
        await archiveItem(id, archive);
      }
    }
  };

  const archiveItem = async (id, archive = false) => {
    detailsDispatch({
      type: "FETCH_REQUEST",
    });

    try {
      const res = await axios.post(`${moduleConfig.url}/archive-item`, {
        id,
        archive,
      });
      loadItem();
      // detailsDispatch({
      //     type: "DELETE_SUCCESS"
      // });
      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `${moduleConfig.singleItemTitle} ${
          archive ? "archived" : "undo archived"
        } successfully.`,
        type: "success",
      });
    } catch (error) {
      detailsDispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });

      setTimeout(() => {
        detailsDispatch({
          type: "REMOVE_ERROR",
        });
      }, 5000);
    }
  };

  const confirmAndChangeBoardMemberStatus = async (id, status) => {
    const isConfirmed = await confirm(
      `Do you really want to ${
        status ? "mark as board member" : "remove from board member"
      }?`,
    );

    if (isConfirmed) {
      await changeBoardMemberStatus(id, status);
    }
  };

  const changeBoardMemberStatus = async (id, status = false) => {
    detailsDispatch({
      type: "FETCH_REQUEST",
    });

    try {
      const res = await axios.post(
        `${moduleConfig.url}/change-status-board-member`,
        {
          id,
          status,
        },
      );
      loadItem();

      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `Member is ${
          status ? "added in" : "removed from"
        } board members list.`,
        type: "success",
      });
    } catch (error) {
      detailsDispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });

      setTimeout(() => {
        detailsDispatch({
          type: "REMOVE_ERROR",
        });
      }, 5000);
    }
  };

  const confirmAndChangeCMSAccessStatus = async (id, status) => {
    const isConfirmed = await confirm(
      `Do you really want to ${
        status ? "allow" : "deny"
      } CMS access for this member?`,
    );

    if (isConfirmed) {
      await changeCMSAccessStatus(id, status);
    }
  };

  const changeCMSAccessStatus = async (id, status = false) => {
    detailsDispatch({
      type: "FETCH_REQUEST",
    });

    try {
      const res = await axios.post(
        `${moduleConfig.url}/change-status-cms-access`,
        {
          id,
          status,
        },
      );
      loadItem();

      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `CMS access is ${status ? "granted" : "denied"}.`,
        type: "success",
      });
    } catch (error) {
      detailsDispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });

      setTimeout(() => {
        detailsDispatch({
          type: "REMOVE_ERROR",
        });
      }, 5000);
    }
  };

  const confirmAndChangeViewMemberDetailsStatus = async (id, status) => {
    const isConfirmed = await confirm(
      `Do you really want to ${
        status ? "allow" : "deny"
      } this member to view other member details?`,
    );

    if (isConfirmed) {
      await changeViewMemberDetailsStatus(id, status);
    }
  };

  const changeViewMemberDetailsStatus = async (id, status = false) => {
    detailsDispatch({
      type: "FETCH_REQUEST",
    });

    try {
      const res = await axios.post(
        `${moduleConfig.url}/change-status-view-member-details`,
        {
          id,
          status,
        },
      );
      loadItem();

      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `View member details access is ${
          status ? "granted" : "denied"
        }.`,
        type: "success",
      });
    } catch (error) {
      detailsDispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });

      setTimeout(() => {
        detailsDispatch({
          type: "REMOVE_ERROR",
        });
      }, 5000);
    }
  };

  const shouldShowArchiveActions = (member) => {
    let returnFlag = false;
    if (
      member.expiryStatus === "membershipIsExpired" ||
      member.blockedByAdmin === "1" ||
      member.status === "EmailVerificationRequired" ||
      member.status === "SignupRequest" ||
      member.status === "SignupRequestRejected" ||
      member.status === "RegistrationPaymentPending" ||
      member.status === "RegistrationPaymentPending" ||
      member.accountDeletionRequested === "1"
    ) {
      returnFlag = true;
    }
    return returnFlag;
  };

  return (
    <DashboardLayout>
      {detailsState.isFetching ? (
        <ContainerLoading />
      ) : (
        <>
          {detailsState.hasError ? (
            <BlockErrorMessage error={detailsState.error} />
          ) : (
            <>
              {detailsState.data.item && (
                <>
                  <ModuleHeader
                    moduleTitle={`View ${moduleConfig.singleItemTitle}`}
                    moduleUrl={moduleConfig.url}
                  ></ModuleHeader>

                  <div className="border mb-1 p-1 bg-light text-white rounded">
                    <Link
                      title="Update Item"
                      to={`/${moduleConfig.url}/update/${detailsState.data.item._id}`}
                      className="btn btn-primary  border me-1"
                    >
                      <i className="fas fa-pencil-alt text-white me-1"></i>{" "}
                      <span className="text-white">Update</span>
                    </Link>

                    <Link
                      title="View Cars"
                      to={`/member-cars/${detailsState.data.item._id}`}
                      className="btn btn-primary border me-1"
                    >
                      <i className="fas fa-car text-white me-1"></i>{" "}
                      <span className="text-white">Cars</span>
                    </Link>

                    {shouldShowArchiveActions(detailsState.data.item) &&
                      userAuthState.user.role === "Admin" && (
                        <>
                          {(!detailsState.data.item.archivedByAdmin ||
                            detailsState.data.item.archivedByAdmin === "0") && (
                            <Link
                              title="Archive Member"
                              onClick={() =>
                                confirmAndChangeArchiveStatus(
                                  detailsState.data.item._id,
                                  true,
                                )
                              }
                              className="btn btn-secondary  border me-1"
                            >
                              <i className="fas fa-arrow-down text-white me-1"></i>{" "}
                              <span className="text-white">Archive Member</span>
                            </Link>
                          )}

                          {detailsState.data.item.archivedByAdmin === "1" && (
                            <Link
                              title="Archive Member"
                              onClick={() =>
                                confirmAndChangeArchiveStatus(
                                  detailsState.data.item._id,
                                  false,
                                )
                              }
                              className="btn btn-success  border me-1"
                            >
                              <i className="fas fa-arrow-up text-white me-1"></i>{" "}
                              <span className="text-white">
                                Undo Archive Member
                              </span>
                            </Link>
                          )}
                        </>
                      )}

                    {detailsState.data.item.expiryStatus ===
                      "membershipIsExpired" &&
                      detailsState.data.item.membershipExpiredThisYear ===
                        false &&
                      detailsState.data.item.clubAdminReactivated === "0" && (
                        <Link
                          title="Reactivate Member"
                          onClick={() =>
                            confirmAndReactivate(detailsState.data.item._id)
                          }
                          className="btn btn-secondary  border me-1"
                        >
                          <i className="fas fa-arrow-up text-white me-1"></i>{" "}
                          <span className="text-white">Reactivate Member</span>
                        </Link>
                      )}

                    {detailsState.data.item.status === "Member" && (
                      <>
                        {detailsState.data.item.blockedByAdmin === "0" &&
                          detailsState.data.item.expiryStatus !==
                            "membershipIsExpired" &&
                          detailsState.data.item.accountDeletionRequested ===
                            "0" && (
                            <>
                              <Link
                                title="View Messages"
                                to={`/chat/member/${detailsState.data.item._id}`}
                                className="btn btn-primary border me-1"
                              >
                                <i className="fas fa-comments text-white me-1"></i>{" "}
                                <span className="text-white">Messages</span>
                              </Link>

                              {(userAuthState.user.role === "Admin" ||
                                userAuthState.user.role === "Club President" ||
                                userAuthState.user.role ===
                                  "Club Vice President") && (
                                <Button
                                  title="Block Member"
                                  onClick={() =>
                                    confirmAndChangeBlockStatus(
                                      detailsState.data.item._id,
                                      true,
                                    )
                                  }
                                  className="btn btn-danger  border me-1"
                                >
                                  <i className="fas fa-ban text-white me-1"></i>{" "}
                                  <span className="text-white">
                                    Block Member
                                  </span>
                                </Button>
                              )}

                              {(userAuthState.user.role === "Admin" ||
                                userAuthState.user.role === "Club President" ||
                                userAuthState.user.role ===
                                  "Club Vice President") && (
                                <Dropdown className="d-inline-block me-1">
                                  <Dropdown.Toggle
                                    variant="secondary"
                                    className="border no-caret"
                                    id="member-actions-dropdown"
                                  >
                                    <i className="fas fa-ellipsis-v text-white"></i>
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu>
                                    {userAuthState.user.role === "Admin" && (
                                      <Dropdown.Item
                                        onClick={() =>
                                          setShowChangeMemberRoleModal(true)
                                        }
                                      >
                                        <i className="fas fa-user me-2"></i>
                                        Change Role
                                      </Dropdown.Item>
                                    )}
                                    {userAuthState.user.role === "Admin" && (
                                      <Dropdown.Item
                                        onClick={() =>
                                          setShowChangeMembershipIdModal(true)
                                        }
                                      >
                                       <i class="fa fa-user-tag me-2"></i>
                                        Change Membership Number
                                      </Dropdown.Item>
                                    )}
                                    {userAuthState.user.role === "Admin" && (
                                      <Dropdown.Item
                                        onClick={() =>
                                          setShowChangeEmailModal(true)
                                        }
                                      >
                                        <i className="fa fa-envelope me-2"></i>
                                        Change Email
                                      </Dropdown.Item>
                                    )}
                                    {userAuthState.user.role === "Admin" && (
                                      <Dropdown.Item
                                        onClick={() =>
                                          confirmAndEmailPassword(
                                            detailsState.data.item._id,
                                            true,
                                          )
                                        }
                                      >
                                        <i className="fas fa-key me-2"></i>
                                        Email Password
                                      </Dropdown.Item>
                                    )}

                                    {userAuthState.user.role === "Admin" && (
                                      <Dropdown.Item
                                        as={Link}
                                        to={`/${moduleConfig.url}/permissions/${detailsState.data.item._id}`}
                                      >
                                        <i className="fas fa-lock me-2"></i>
                                        Manage Permissions
                                      </Dropdown.Item>
                                    )}
                                  </Dropdown.Menu>
                                </Dropdown>
                              )}
                            </>
                          )}
                      </>
                    )}

                    {detailsState.data.item.status === "SignupRequest" && (
                      <>
                        {(userAuthState.user.role === "Admin" ||
                          userAuthState.user.role === "Club President" ||
                          userAuthState.user.role ===
                            "Club Vice President") && (
                          <>
                            <Link
                              title="Accept Request"
                              onClick={() =>
                                confirmAndRespondToSignupRequest(
                                  detailsState.data.item._id,
                                  true,
                                )
                              }
                              className="btn btn-success  border me-1"
                            >
                              <i className="fas fa-times text-white me-1"></i>{" "}
                              <span className="text-white">Accept Request</span>
                            </Link>

                            <Link
                              title="Reject Request"
                              onClick={() =>
                                confirmAndRespondToSignupRequest(
                                  detailsState.data.item._id,
                                  false,
                                )
                              }
                              className="btn btn-danger  border me-1"
                            >
                              <i className="fas fa-times text-white me-1"></i>{" "}
                              <span className="text-white">Reject Request</span>
                            </Link>
                          </>
                        )}
                      </>
                    )}

                    {detailsState.data.item.blockedByAdmin === "1" && (
                      <>
                        {(userAuthState.user.role === "Admin" ||
                          userAuthState.user.role === "Club President" ||
                          userAuthState.user.role ===
                            "Club Vice President") && (
                          <Link
                            title="Unblock Request"
                            onClick={() =>
                              confirmAndChangeBlockStatus(
                                detailsState.data.item._id,
                                false,
                              )
                            }
                            className="btn btn-success  border me-1"
                          >
                            <i className="fas fa-undo text-white me-1"></i>{" "}
                            <span className="text-white">Unblock Member</span>
                          </Link>
                        )}
                      </>
                    )}
                  </div>

                  {detailsState.data.item.status != "SignupRequest" && (
                    <>
                      <Details
                        item={detailsState.data.item}
                        moduleConfig={moduleConfig}
                      />
                    </>
                  )}
                  {detailsState.data.item.status === "SignupRequest" && (
                    <>
                      <DetailsSignup
                        item={detailsState.data.item}
                        moduleConfig={moduleConfig}
                      />
                    </>
                  )}
                  {detailsState.data.item.status === "Member" && (
                    <>
                      <MemberCircles items={detailsState.data.circles} />

                      <MemberRecentRegistrations
                        items={detailsState.data.registrations}
                      />
                    </>
                  )}
                  {(detailsState.data.item.status === "Member" ||
                    detailsState.data.item.status ===
                      "RegistrationPaymentPending") && (
                    <MemberRecentPayments items={detailsState.data.payments} />
                  )}
                  <SignupRequestRejectModal
                    memberId={detailsState.data.item._id}
                    show={showRejectionModal}
                    setShow={setShowRejectionModal}
                    loadItem={loadItem}
                  />

                  <AddMembershipIdModal
                    memberId={detailsState.data.item._id}
                    show={showAddMembershipIdModal}
                    setShow={setShowAddMembershipIdModal}
                    loadItem={loadItem}
                  />

                  <ChangeMemberRoleModal
                    memberId={detailsState.data.item._id}
                    initialValue={detailsState.data.item.role}
                    show={showChangeMemberRoleModal}
                    setShow={setShowChangeMemberRoleModal}
                    loadItem={loadItem}
                  />
                   <ChangeMembershipIdModal
                    memberId={detailsState.data.item._id}
                    initialValue={detailsState.data.item.oldMemberNumber}
                    show={showChangeMembershipIdModal}
                      member={detailsState.data.item}
                    setShow={setShowChangeMembershipIdModal}
                    loadItem={loadItem}
                  />
                  <ChangeMemberEmailModal
                    memberId={detailsState.data.item._id}
                    initialValue={detailsState.data.item.email}
                    member={detailsState.data.item}
                    show={showChangeEmailModal}
                    setShow={setShowChangeEmailModal}
                    loadItem={loadItem}
                  />
                  <MemberArchiveModal
                    memberId={detailsState.data.item._id}
                    show={showArchiveModal}
                    setShow={setShowArchiveModal}
                    loadItem={loadItem}
                  />

                  <MemberReactivateModal
                    memberId={detailsState.data.item._id}
                    show={showReactivateModal}
                    setShow={setShowReactivateModal}
                    loadItem={loadItem}
                  />
                </>
              )}
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default MemberView;
